import React, { useState } from 'react'
import './LargeFlatButton.css'

type LedColor = 'amber' | 'emerald' | 'green' | 'lime' | 'cyan' | 'red'

interface LargeFlatButtonProps {
  labelTop: string
  ledColor: LedColor
  onClick?: () => void
  disabled?: boolean
  isActive?: boolean
}

const LargeFlatButton: React.FC<LargeFlatButtonProps> = ({
  labelTop,
  ledColor = 'amber',
  onClick,
  disabled = false,
  isActive: controlledIsActive,
}) => {
  const [internalIsActive, setInternalIsActive] = useState(false)

  // Use controlled state if provided, otherwise use internal state
  const isActive =
    controlledIsActive !== undefined ? controlledIsActive : internalIsActive

  const handleClick = () => {
    if (disabled) return

    // Toggle internal state if not controlled
    if (controlledIsActive === undefined) {
      setInternalIsActive(!internalIsActive)
    }

    // Call the onClick handler if provided
    onClick?.()
  }

  return (
    <div className="large-control-unit" onClick={handleClick}>
      <span className="large-control-label">{labelTop}</span>

      {/* LED Indicator */}
      <div className={`led ${ledColor} ${isActive ? 'active' : 'inactive'}`} />

      {/* Physical Button */}
      <button
        className={`large-hw-btn-housing ${isActive ? 'active' : ''}`}
        disabled={disabled}
      >
        <div className="large-hw-btn-inner">
          <div className="large-hw-btn-face">
            <div className="large-hw-btn-highlight" />
          </div>
          <div className="large-hw-btn-lip" />
        </div>
      </button>
    </div>
  )
}

export default LargeFlatButton
